import React, {Component, useEffect} from 'react';
import {reset} from 'redux-form';
import {connect} from 'react-redux';
import BancoDeDadosNacionalApi from '../../../logicas/BancoDeDadosNacional/BancoDeDadosNacionalApi'

class BancoDeDadosNacional extends Component {
  constructor(props) {
    super(props);
    props.history.push('/lei');
  }
  render() {
    const disparaEnvioDeEmail = (values) =>
      new Promise(resolve => {
        this.props.enviaEmail(values, resolve, reset);
      });

    const FormEmissor = require('./FormEmissor').default;

    return (
      <div>
        <section className="py-5">
          <div className="meiaentrada-title mb-5">
            <div className="container">
              <div className="meiaentrada-title-border-hide">
                <h1>Validador da Meia Entrada</h1>
              </div>
            </div>
          </div>
          <div className="container">
            <p>
              O validador do MeiaEntrada.org.br, consolida em um único repositório o certificado A3 das entidades estudantis,
              possibilitando a consulta pública dos certificados de atributo contidos nas CIEs, fornecendo aos estabelecimentos, ticketeiras e produtores de eventos ferramentas para que eles possam validar as Carteiras de Identificação Estudantil
              (CIE) dos estudantes que pretendem comprar meia-entrada. Desta forma, além de o direito ser garantido a
              quem realmente o detém, o procedimento de conferência automatizada agiliza o processo e garante a
              segurança e sigilo dos dados.
            </p>
          </div>
        </section>

        <section className="pb-5">
          <div className="meiaentrada-title mb-5">
            <div className="container">
              <div className="meiaentrada-title-border-hide">
                <h2>Dados para cadastro de Entidades Estudantis</h2>
              </div>
            </div>
          </div>

          <div className="container">
            <p>
              Preencha o formulário abaixo (todos os campos são obrigatórios) que entraremos em contato para
              iniciar a validação sistêmica das CIEs.
            </p>
            <p>
              Antes de solicitar o seu cadastramento como representante de uma Entidade Estudantil no
              meiaentrada.org.br, tenha a certeza de que a sua organização já possui a chave pública do certificado
              digital usado na geração dos CA-CIEs ( Certificado de Atributos da Carteira de Identificação Estudantil), 
              e que estes estão aderentes a Portaria ITI nº 78 de dezembro de 2018, bem como aos dispositivos da
              Lei Federal nº 12.933/13.
            </p>
            <p>
              Consulte sua área de TI no caso de dúvidas.
            </p>

            <div className="row justify-content-center">

              <div className="form-style col-md-10 col-lg-8 col-xl-6 py-4 px-5">
                <FormEmissor onSubmit={disparaEnvioDeEmail}/>
              </div>

            </div>
          </div>
        </section>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return state
};

const mapDispatchToProps = dispatch => {
  return {
    enviaEmail: (values, resolve, reset) => {
      dispatch(BancoDeDadosNacionalApi.enviaEmail(values, resolve, reset))
    }
  }
};

const BancoDeDadosNacionalContainer = connect(mapStateToProps, mapDispatchToProps)(BancoDeDadosNacional);

export default BancoDeDadosNacionalContainer


// WEBPACK FOOTER //
// ./src/components/views/BancoDeDadosNacional/BancoDeDadosNacional.js